/**
 * Options:
 * not_single_product: true - treat bundle as a bundle even if only one product
 *
 * IMPORTANT: Updating of the following kits is mandatory on fasciablaster.com as well!!!
 * Beginner_Kit, Platinum_Pack, Cellulite_Mini_Paddle_Kit, The_Mini_Kit, Brush_and_Blast
 *
 *
 * IMPORTANT: Updating of the following kits is mandatory on homepage bundles_array as well!!!
 * The_Starter_Kit, Beginner_Kit
 *
 */

var bundles_array = [
  {
    bundle_name: 'Beginner Kit',
    bundle_class: 'Beginner_Kit',
    sold: false,
    bundle_discount: 41.8410042, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Back Pack',
    bundle_class: 'Back_Pack',
    sold: false,
    bundle_discount: 44.64088,
    bundle_components: [
      {id: 39360944308320, price:99.00, replace_variant:39360944341088, replace_price: 99.00}, // Extenders 
      {id: 39249212244064, price:125.00}, // BigDaddy FasciaBlaster®
      {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  },
  {
    bundle_name: 'BLASTER OIL® AND AFTERBLASTER CREAM™',
    bundle_class: 'Blaster_Oil_and_After_Blaster_Cream_set',
    sold: false,
    bundle_discount: 0,
    bundle_components: [
      {id: 32669289447520, price:19.00}, // ROLL ON BLASTER OIL
      {id: 19825070506080, price:19.00} // 3.5 OZ AfterBlaster Cream™
    ]
  },
  {
    bundle_name: 'Monthly Body Care Essentials Kit',
    bundle_class: 'Monthly_Body_Care_Essentials',
    sold: false,
    bundle_discount: 27.6315789,
    bundle_components: [
      {id: 19825070506080, price:19.00}, // 3.5 OZ AfterBlaster Cream™
      {id: 19824951165024, price:19.00, replace_variant:19824951165024, replace_price: 19.00,qty: 3}, // 3.4 OZ Blaster Oil® Unscented Uncented
    ]
  },
   {
    bundle_name: 'Blaster Duo',
    bundle_class: 'Blaster_Duo',
    sold: false,
    bundle_discount: 50,
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Mini Paddle and Savage Blaster',
    bundle_class: 'Mini_Paddle_Savage_Blaster',
    sold: false,
    bundle_discount: 50,
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 39352817320032, price:225.00} // Savage Blaster
    ]
  },
  {
    bundle_name: 'Savage Blaster',
    bundle_class: 'Savage_Blaster',
    sold: false,
    bundle_discount: 40,
    bundle_components: [
      {id: 39352817320032, price:225.00} // Savage Blaster
    ]
  },
  {
    bundle_name: 'Blasting and Kryo Combo',
    bundle_class: 'Blasting_and_Kryo_Combo',
    sold: false,
    bundle_discount: 37.71428571428571, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Starter Foot Kit',
    bundle_class: 'Starter_Foot_Kit',
    sold: false,
    bundle_discount: 30.5555556,
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00} // Mini 2™
    ]
  },
    {
    bundle_name: 'Pro-Foot Kit',
    bundle_class: 'Pro_Foot_Kit',
    sold: false,
    bundle_discount: 35.24229074889868,
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 39343279997024, price:64.00}, // Ashley Black’s Kryopack ™ Kryoboot
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  { 
    bundle_name: 'Summer Body Kit',
    bundle_class: 'Summer_Body_Kit',
    sold: false,
    bundle_discount: 46.7914439, 
    bundle_components: [
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 32669494214752, price:149.00} // Ashley Black's Kryomat™ Medium
    ]
  },
  { 
    bundle_name: 'Face Duo',
    bundle_class: 'Face_Duo',
    sold: false,
    bundle_discount: 40.3846154, 
    bundle_components: [
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 32669495459936, price:59.00} // Ashley Black's ™ Deluxe Serum
    ]
  },
  { 
    bundle_name: 'Face And Neck Starter Kit',
    bundle_class: 'Face_And_Neck_Starter_Kit',
    sold: false,
    bundle_discount: 51.2345679, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32669495459936, price:59.00}, // Ashley Black's ™ Deluxe Serum
      {id: 32183244062816, price:34.00} // Ashley Black's Kryopack™ Face Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 34991941644, // #Blastersquad Headband
      price:89.00, replace_variant:34991941580, replace_price: 89.00}
	]
  }
  },
  { 
    bundle_name: 'Mini Tension Headache Kit',
    bundle_class: 'Mini_Tension_Headache_Kit',
    sold: false,
    bundle_discount: 25.5639098, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™ 
      {id: 19824951165024, price:19.00, replace_variant:19824951165024, replace_price: 19.00}, // 3.4 OZ Blaster Oil® Unscented Uncented
      {id: 32183250583648, price:45.00} // Ashley Black's Kryopack™ Jaw/small Area Wrap
    ]
  },
  { 
    bundle_name: 'Tension Headache Kit',
    bundle_class: 'Tension_Headache_Kit',
    sold: false,
    bundle_discount: 30.5147059, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™ 
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget
      {id: 19824951165024, price:19.00, replace_variant:19824951165024, replace_price: 19.00}, // 3.4 OZ Blaster Oil® Unscented Uncented
      {id: 32183250583648, price:45.00}, // Ashley Black's Kryopack™ Jaw/small Area Wrap
      {id: 32183244062816, price:34.00} // Ashley Black's Kryopack™ Face Wrap
    ], free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 39348737638496, price:29.00} // Mini Back Pack
	]
  }
  },
  {
    bundle_name: 'Brush & Blast',
    bundle_class: 'Brush_and_Blast',
    sold: false,
    bundle_discount: 50, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00, qty: 2} // Brush booster
    ]
  },
  {
    bundle_name: 'Brush & Blast ',
    bundle_class: 'Brush_and_Blast_email',
    sold: false,
    bundle_discount: 50, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00, qty: 2} // Brush booster
    ]
  },
  {
    bundle_name: 'Silk Set',
    bundle_class: 'Silk_Set',
    sold: false,
    bundle_discount: 60.35502958579882, 
    bundle_components: [
    {id: 39563673436256, price: 69.00}, // Silk Pillowcase
    {id: 39563677270112, price: 16.00}, // Scrunchy
    {id: 39563680546912, price: 69.00}, // Silk Turban
    {id: 39559432077408, price:15.00} // Satin cinch Bag
    ]
  },
  {
    bundle_name: 'Silk Set',
    bundle_class: 'Silk_Set_OS',
    sold: false,
    bundle_discount: 60.3550296, 
    bundle_components: [
    {id: 39563673436256, price: 69.00}, // Silk Pillowcase
    {id: 39563677270112, price: 16.00}, // Scrunchy
    {id: 39563680546912, price: 69.00}, // Silk Turban
    {id: 39559432077408, price:15.00} // Satin cinch Bag
    ]
  },
  {
    bundle_name: 'Bare Bones Kit',
    bundle_class: 'Bare_Bones_Kit',
    sold: false,
    bundle_discount: 35.710111, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)   
   ]
  },
  {
      bundle_name: 'Face and Neck Upgraded Kit',
      bundle_class: 'Face_and_Neck_Upgraded_Kit',
      sold: false,
      bundle_discount: 22.8753829, 
      bundle_components: [
        {id: 39391782371424, price: 149.00}, // OMGBlaster
        {id: 32669289447520, price: 19.00}, // ROLL ON BLASTER OIL
        {id: 32669495459936, price:59.00}, // Ashley Black's ™ Deluxe Serum
        {id: 32183244062816, price:34.00}, // Ashley Black's Kryopack™ Face Wrap
        {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)   
     ]
  },
  {
    bundle_name: 'Hair Luxury Kit',
    bundle_class: 'Hair_Luxury_Kit',
    sold: false,
    bundle_discount: 20.1342282, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 39563673436256, price: 69.00}, // Silk Pillowcase
      {id: 39563680546912, price: 69.00}, // Glam Wrap
      {id: 39563677270112, price: 16.00} // Scrunchy
   ]
  },
  {
    bundle_name: 'Hair Upgraded Kit',
    bundle_class: 'Hair_Upgraded_Kit',
    sold: false,
    bundle_discount: 10.4166667, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00} // Mini 2™ 
   ]
  },
  {
    bundle_name: 'Face and Neck Luxury Kit',
    bundle_class: 'Face_and_Neck_Luxury_Kit',
    sold: false,
    bundle_discount: 28.0289399,
    bundle_components: [
      {id: 39391782371424, price: 149.00}, // OMGBlaster
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32669495459936, price: 59.00}, // Ashley Black's ™ Deluxe Serum
      {id: 32669289447520, price: 19.00}, // ROLL ON BLASTER OIL
      {id: 32183244062816, price: 34.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 32183246454880, price: 34.00}, // Ashley Black's Kryopack™ Eye Wrap
      {id: 39563673436256, price: 69.00}, // Silk Pillowcase
      {id: 39563680546912, price: 69.00}, // Glam Wrap
      {id: 39563677270112, price: 16.00}, // Scrunchy
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)   
    ]
  },
  {
    bundle_name: 'Face and Neck Essential Kit',
    bundle_class: 'Face_and_Neck_Essential_Kit',
    sold: false,
    bundle_discount: 10.15625, 
    bundle_components: [
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, price: 69.00}, // FaceBlaster™
      {id: 32669495459936, price: 59.00} // Ashley Black's ™ Deluxe Serum
    ]
  },
  {
    bundle_name: 'Brush Booster Bundle',
    bundle_class: 'Brush_Booster_Bundle',
    sold: false,
    bundle_discount: 33.14606741573034, 
    not_single_product: true,
    bundle_components: [
      {id: 39559479459936, price: 89.00, qty: 2} // Brush booster
    ]
  },
    {
    bundle_name: 'Stubborn Belly Fat Kit',
    bundle_class: 'Stubborn_Belly_Fat_Kit',
    sold: false,
    bundle_discount: 53.26086956521739, 
    bundle_components: [
    {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
    {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
    {id: 2433847951372, price:35.00}, // FasciaYoga™ Ball
    {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
    {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Small Gift Bag',
    bundle_class: 'Small_Gift_Bag',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 39601898586208, price:4.00} // Gift Bag Small 
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39642277150816, price: 0.01} // Tissue Paper
      ]
  }
  },
  {
    bundle_name: 'Medium Gift Bag',
    bundle_class: 'Medium_Gift_Bag',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 39601898618976, price:5.00} // Gift Bag Small 
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39642277150816, price: 0.01} // Tissue Paper
      ]
  }
  },
  {
    bundle_name: 'Large Gift Bag',
    bundle_class: 'Large_Gift_Bag',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 39601898651744, price:7.00} // Gift Bag Small 
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39642277150816, price: 0.01} // Tissue Paper
      ]
  }
  },
  {
    bundle_name: 'Yoga & Pilates Kit',
    bundle_class: 'Yoga_And_Pilates_Kit',
    sold: false,
    bundle_discount: 32.19440130307966, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00} // FasciaBlaster® Nugget
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
      ]
    }
  },
  {
    bundle_name: 'Dynamic Duo',
    bundle_class: 'Dynamic_Duo',
    sold: false,
    bundle_discount: 20.212766, 
    bundle_components: [
      {id: 39356795945056, price: 99.00}, // Cupping Set
      {id: 39559479459936, price: 89.00} // Brush booster
    ]
  },
    {
    bundle_name: 'The Dynamic Duo',
    bundle_class: 'The_Dynamic_Duo',
    sold: false,
    bundle_discount: 45.13888888888889, 
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 40689249779808, price:19.00, replace_variant:40134628999264, replace_price: 19.00} // Blaster Oil®️ Essentials 
    ]
  },
  {
    bundle_name: 'Starter Kit',
    bundle_class: 'Starter_Kit',
    sold: false,
    bundle_discount: 35.15981735159817, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'The Starter Kit',
    bundle_class: 'The_Starter_Kit',
    sold: false,
    bundle_discount: 16.730038, 
    bundle_components: [
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, price: 69.00}, // FaceBlaster™
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
      {
    bundle_name: 'The Starter Kit 2',
    bundle_class: 'The_Starter_Kit_2',
    sold: false,
    bundle_discount: 24.3346008, 
    bundle_components: [
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, price: 69.00}, // FaceBlaster™
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
    {
    bundle_name: 'The Starter Kit 3',
    bundle_class: 'The_Starter_Kit_3',
    sold: false,
    bundle_discount: 43.3460076, 
    bundle_components: [
      {id: 32917301756000, price: 69.00, replace_variant: 32917301788768, price: 69.00}, // FaceBlaster™
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 32183192780896, price:46.00}, // Ashley Black's Kryopack™ Back And Abs Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Luxe Kit',
    bundle_class: 'Luxe_Kit',
    sold: false,
    bundle_discount: 45.01510574018127, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 40689249779808, price:19.00, qty:3, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Dual Problasters',
    bundle_class: 'Dual_Problasters',
    sold: false,
    bundle_discount: 50,  
    not_single_product: true,
    bundle_components: [
      {id: 39510434545760, price: 125.00, qty:2} // ProBlaster™️️️️️️
    ]
  },
  {
    bundle_name: 'Trauma Kit',
    bundle_class: 'Trauma_Kit',
    sold: false,
    bundle_discount: 50,  
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00,qty:2}, // Brush booster
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32669494214752, price:149.00} // Ashley Black's Kryomat™ Medium
    ]
  },
  {
    bundle_name: 'Nugget Small Kit',
    bundle_class: 'Nugget_Small_Kit',
    sold: false,
    bundle_discount: 30.3797468,  
    bundle_components: [
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 39559483818080, price:49.00} // Mini Nugget Trigger Point with handle
    ]
  },
  {
    bundle_name: 'The Bare Bones Pelvic Kit',
    bundle_class: 'The_Bare_Bones_Pelvic_Kit',
    sold: false,
    bundle_discount: 33.05084745762712, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 32183156179040, price:22.00} // Ashley Black's Kryopack™ Wrap
      ]
    }
  },
    {
    bundle_name: 'The Stubborn Spots Kit',
    bundle_class: 'The_Stubborn_Spots_Kit',
    sold: false,
    bundle_discount: 42.7745665, 
    bundle_components: [
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 39559483818080, price:49.00}, // Mini Nugget Trigger Point with handle
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 32182654795872, price:22.00} // Ashley Black's Kryopack™ Spot
      ]
    }
  },
  {
    bundle_name: 'Elbow Kit',
    bundle_class: 'Elbow_Kit',
    sold: false,
    bundle_discount: 15.76923076923077, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 40134628999264, price:15.00}, // NEW Blaster Oil
      {id: 32183250583648, price:45.00} // Ashley Black's Kryopack™ Jaw/small Area Wrap
    ]
  },
  {
    bundle_name: 'Power Trio',
    bundle_class: 'Power_Trio',
    sold: false,
    bundle_discount: 50.1002004, 
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 39391782371424, price:149.00} // OMGBlaster

    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      ]
    }
  },
  {
    bundle_name: 'The Brisk Blast Kit',
    bundle_class: 'The_Brisk_Blast_Kit',
    sold: false,
    bundle_discount: 41.0958904109589, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 32182654795872, price:22.00}, // Ashley Black's Kryopack™ Spot
      {id: 40134628999264, price:15.00} // NEW Blaster Oil
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      ]
    }
  },
  {
    bundle_name: 'The Top Tools Kit',
    bundle_class: 'The_Top_Tools_Kit',
    sold: false,
    bundle_discount: 36.62420382165605,
    bundle_components: [
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 40134628999264, price:15.00} // NEW Blaster Oil
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      ]
    }
  },
  {
    bundle_name: 'The Gentle Kit',
    bundle_class: 'The_Gentle_Kit',
    sold: false,
    bundle_discount: 41.84100418410042,
    bundle_components: [
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 40134628999264, price:15.00}, // NEW Blaster Oil
      {id: 32183192780896, price:46.00} // Ashley Black's Kryopack™ Back And Abs Wrap
    ]
  },
  {
    bundle_name: 'The Big Boy Kit',
    bundle_class: 'The_Big_Boy_Kit',
    sold: false,
    bundle_discount: 46.27249357326478,
    bundle_components: [
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 40134628999264, price:15.00}, // NEW Blaster Oil
      {id: 32669494214752, price:149.00}, // Ashley Black's Kryomat™ Medium
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [{id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99}] // Cellulite Myth Book
    }
  },
  {
    bundle_name: 'The Mini Paddle Kit',
    bundle_class: 'The_Mini_Paddle_Kit',
    sold: false,
    bundle_discount: 43.74680379567021, 
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book) 
    ]
  },
  {
    bundle_name: 'NYNY Starter Kit for Newbies',
    bundle_class: 'NYNY_Starter_Kit_for_Newbies',
    sold: false,
    bundle_discount: 30.37974683544304, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 40134628999264, price:15.00, replace_variant: 40689249779808, replace_price: 19.00}, // NEW Blaster Oil
      {id: 32182654795872, price:22.00} // Spot KryoPack
   ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 43882392588, price:20.00} // Ashley Black - Snapback  AB Hat
      ] 
    }
  },
  {
    bundle_name: 'The Cellulite Starter Kit',
    bundle_class: 'The_Cellulite_Starter_Kit',
    sold: false,
    bundle_discount: 47.8671432, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget  
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
      {id: 32183156179040, price:22.00} // Ashley Black's Kryopack™ Wrap
   ]
  },
  {
    bundle_name: 'NYNY Starter Kit for Upping Your Game',
    bundle_class: 'NYNY_Starter_Kit_for_Upping_Your_Game',
    sold: false,
    bundle_discount: 40.46094750320102, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 39747130654816, price: 125.00}, // ProNugget
      {id: 39356795945056, price: 99.00}, // Cupping Set
      {id: 2433847951372, price:35.00}, // FasciaYoga™ Ball
      {id: 32669494214752, price:149.00}, // Ashley Black's Kryomat™ Medium
      {id: 40134628999264, price:15.00, qty: 3}, // NEW Blaster Oil
      {id: 40134628999264, price:15.00, qty: 3, replace_variant: 40689249779808, replace_price: 19.00, qty: 3}, // NEW Blaster Oil

   ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 43882392588, price:20.00}, // Ashley Black - Snapback  AB Hat
        {id: 39245878591584, price:39.00} // Sauna Suit
      ] 
    }
  },
    {
    bundle_name: "Full Body Blasting",
    bundle_class: 'Full_Body_Blasting',
    sold: false,
    bundle_discount: 21.20582120582121,
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00} // FasciaBlaster® Nugget 
    ]
  },
    {
    bundle_name: "Shoulders, Elbows, and Knees Kit",
    bundle_class: 'Shoulders_Elbows_Knees_Kit',
    sold: false,
    bundle_discount: 16.66666666666667,
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 39747130654816, price: 125.00}, // ProNugget
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32183192780896, price:46.00} // Ashley Black's Kryopack™ Back And Abs Wrap
    ]
  },
    {
    bundle_name: "Feet and Ankles, Wrist and Neck Kit",
    bundle_class: 'Feet_Ankles_Wrist_Neck_Kit',
    sold: false,
    bundle_discount: 35.24229074889868,
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 39343279997024, price:64.00} // Ashley Black’s Kryopack ™ Kryoboot
    ]
  },
  {
    bundle_name: 'The Contouring Kit',
    bundle_class: 'The_Contouring_Kit',
    sold: false,
    bundle_discount: 45.37414376138039, 
    not_single_product: true,
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 2433847951372, price:35.00}, // FasciaYoga™ Ball
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
   ]
  },
  {
    bundle_name: 'Compact Kit',
    bundle_class: 'Compact_Kit',
    sold: false,
    bundle_discount: 49.4117647, 
    not_single_product: true,
    bundle_components: [
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 2433847951372, price:35.00}, // FasciaYoga™ Ball
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
   ]
  },
  {
    bundle_name: 'Hydrogel Kit',
    bundle_class: 'Hydrogel_Kit',
    sold: false,
    bundle_discount: 70,
    bundle_components: [
      {id: 39559436730464, price: 29.00}, // Eye Patch Hydrogel (7 pack)
      {id: 39559439941728, price: 39.00}, // Hydrogel Jawline Patch (7 pack)
      {id: 39559433781344, price: 29.00}, // Lip Patch Hydrogels (7 pack)
      {id: 39559441907808, price: 39.00}, // Décolleté Neck Hydrogel
      {id: 39559445119072, price: 29.00} // Forehead Hydrogel (7 pack)
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39559433191520, price:22.00} // MAXIMUM LIP
      ] 
    }
  }, 
  { // Vday sale kit
    bundle_name: 'For me, For you Kit',
    bundle_class: 'For_me_For_you_Kit',
    sold: false,
    bundle_discount: 41.9642857,
    bundle_components: [
      {id: 39249212244064, price: 125.00}, // BigDaddy FasciaBlaster® 
      {id: 39360944341088, price:99.00, replace_variant:39360944308320, replace_price: 99.00} // Extenders 
   ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 40134628999264, price:15.00, replace_variant: 40689249779808, replace_price: 19.00}, // NEW Blaster Oil
      ] 
    }
  },
  { // Vday sale kit
    bundle_name: 'Face Lovers Kit',
    bundle_class: 'Face_Lovers_Kit',
    sold: false,
    bundle_discount: 60.71428571428571,
    bundle_components: [
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32183244062816, price:34.00} // Ashley Black's Kryopack™ Face Wrap 
   ],
},
  { // Vday sale kit
    bundle_name: 'Body Lovers Kit',
    bundle_class: 'Body_Lovers_Kit',
    sold: false,
    bundle_discount: 40.4, 
    bundle_components: [
      {id: 39747130654816, price: 125.00}, // ProNugget
      {id: 39510434545760, price: 125.00} // ProBlaster™️️️️️️
   ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 40134628999264, price:15.00, replace_variant: 40689249779808, replace_price: 19.00}, // NEW Blaster Oil
      ] 
    }
  },
  {
    bundle_name: "New Roller Oils Kit",
    bundle_class: 'New_Roller_Oils_Kit',
    sold: false,
    bundle_discount: 33.3333333,
    not_single_product: true,
    bundle_components: [
      {id: 40134628999264, price:15.00, qty: 3,replace_variant: 40689249779808, replace_price: 19.00, qty: 3} // NEW Blaster Oil
    ]
  },
  {
    bundle_name: 'Cellulite Mini Paddle Kit',
    bundle_class: 'Cellulite_Mini_Paddle_Kit',
    sold: false,
    bundle_discount: 43.74680379567021, 
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book) 
    ]
  },
  {
    bundle_name: 'Single Deluxe Serum',
    bundle_class: 'Single_Deluxe_Serum',
    sold: false,
    bundle_discount: 16.9491525, 
    not_single_product: false,
    bundle_components: [
      {id: 32669495459936, price:59.00} // Ashley Black's ™ Deluxe Serum
    ]
  },
    {
      bundle_name: 'Platinum Pack',
      bundle_class: 'Platinum_Pack_V1',
      sold: false,
      bundle_discount: 70.23656268344679, 
      not_single_product: true,
      bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 39747130654816, price: 125.00}, // ProNugget 
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99}, // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book) 
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 39559479459936, price: 89.00}, // Brush booster
      {id: 40689249779808, price:19.00}, // Blaster Oil®️ Essentials
      {id: 32669495459936, price: 59.00}, // Ashley Black's ™ Deluxe Serum
      {id: 39559432077408, price:15.00}, // Satin cinch Bag
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      ],
  },
  {
    bundle_name: 'Cup and Blast Kit',
    bundle_class: 'Cup_and_Blast_Kit',
    sold: false,
    bundle_discount: 27.9835391,
    bundle_components: [
      {id: 39356795945056, price: 99.00}, // Cupping Set
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 19824951165024, price:19.00} // 3.4 OZ Blaster Oil® Scented
    ]
  },
  {
      bundle_name: 'OMGBlaster And Eye Kryowrap',
      bundle_class: 'OMGBlaster_And_Eye_Kryowrap',
      sold: false,
      bundle_discount: 67.75956284153005,
      bundle_components: [
      {id: 39391782371424, price:149.00}, // OMGBlaster
      {id: 32183246454880, price:34.00} // Ashley Black's Kryopack™ Eye Wrap
    ]
    },
    {
      bundle_name: 'Luxury Layers Kit',
      bundle_class: 'Luxury_Layers_Kit',
      sold: false,
      bundle_discount: 45.13172966781214,
      bundle_components: [
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 32917313159264, price:30.00, replace_variant:32917313192032, replace_price: 30.00}, // FasciaBlaster® Nugget 
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 39391782371424, price: 149.00}, // OMGBlaster
      {id: 32183244062816, price: 34.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 32183262675040, price:57.00} // Ashley Black's Kryomat™ Small
    ]
    },
  {
      bundle_name: 'Luxury Face Kit',
      bundle_class: 'Luxury_Face_Kit',
      sold: false,
      bundle_discount: 42.81609195402299,
      bundle_components: [
      {id: 39559436730464, price: 29.00}, // Eye Patch Hydrogel (7 pack)
      {id: 39559439941728, price: 39.00}, // Hydrogel Jawline Patch (7 pack)
      {id: 39559433781344, price: 29.00}, // Lip Patch Hydrogels (7 pack)
      {id: 39559441907808, price: 39.00}, // Décolleté Neck Hydrogel
      {id: 39559445119072, price: 29.00}, // Forehead Hydrogel (7 pack)
      {id: 32183244062816, price:34.00}, // Ashley Black's Kryopack™ Face Wrap
      {id: 39391782371424, price: 149.00} // OMGBlaster      
    ]
    },
    {
      bundle_name: 'Luxury Hair Kit',
      bundle_class: 'Luxury_Hair_Kit',
      sold: false,
      bundle_discount: 38.65979381443299,
      bundle_components: [
      {id: 39747130654816, price: 125.00}, // ProNugget 
      {id: 39563680546912, price: 69.00} // Glam Wrap        
    ]
    },
  {
    bundle_name: 'The Longevity Kit',
    bundle_class: 'The_Longevity_Kit',
    sold: false,
    bundle_discount: 66.21392190152801, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39352817320032, price:225.00}, // Savage Blaster
      {id: 40134628999264, price:15.00, replace_variant: 40689249779808, replace_price: 19.00}, // NEW Blaster Oil
      {id: 32669492117600, price:199.00} // Ashley Black's Kryomat™ Large
    ]
  },
  {
    bundle_name: 'OMGBlaster',
    bundle_class: 'OMGBlaster_Kit',
    sold: false,
    bundle_discount: 46.9798658, 
    not_single_product: true,
    bundle_components: [
      {id: 39391782371424, price:149.00} // OMGBlaster
    ]
  },
  {
    bundle_name: 'OMG and Silk Set',
    bundle_class: 'OMG_and_Silk_Set',
    sold: false,
    bundle_discount: 61.72106824925816, 
    bundle_components: [
      {id: 39391782371424, price:149.00}, // omgblaster
      {id: 39563673436256, price: 69.00}, // Silk Pillowcase
      {id: 39563677270112, price: 16.00}, // Scrunchy
      {id: 39563680546912, price: 69.00}, // Silk Turban
      {id: 39559432077408, price:15.00}, // Satin cinch Bag
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'The Pro Duo',
    bundle_class: 'The_Pro_Duo',
    sold: false,
    bundle_discount: 40.4, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 39747130654816, price: 125.00} // ProNugget 
    ]
  },
  {
    bundle_name: 'The Mini Kit',
    bundle_class: 'The_Mini_Kit',
    sold: false,
    bundle_discount: 46.48648648648649,
    bundle_components: [
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'The Urban Wellness Super Starter Kit',
    bundle_class: 'The_Urban_Wellness_Super_Starter_Kit',
    sold: false,
    bundle_discount: 37.6130198915009,
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base 
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 39391782371424, price:149.00}, // OMGBlaster 
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
},
  { 
    bundle_name: 'Blaster Oil Essentials x3',
    bundle_class: 'Blaster_Oil_Essentials',
    sold: false,
    bundle_discount: 33.3333333,
    not_single_product: true,
    bundle_components: [
      {id: 40689249779808, price:19.00,qty:3, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
   ]
  },
  {
    bundle_name: "The Cellulite Easy Start Kit",
    bundle_class: 'The_Cellulite_Easy_Start_Kit',
    sold: false,
    bundle_discount: 50.5320474,
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
      {id: 32183156179040, price:22.00}, // Wrap KryoPack
      {id: 41367238705248, price:9.99, replace_variant: 41367238738016, replace_price: 9.99} // The Cellulite Myth: It's Not Fat, It's Fascia by Ashley Black; (Paperback Book)
    ]
  },
  {
    bundle_name: 'Skin Care Kit',
    bundle_class: 'Skin_Care_Kit',
    sold: false,
    bundle_discount: 45.41284403669725, 
    bundle_components: [
      {id: 39391782371424, price:149.00}, // omgblaster
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00} // FaceBlaster™
    ]
  },
  {
    bundle_name: 'FasciaYoga Ball',
    bundle_class: 'FasciaYoga_Ball_email',
    sold: false,
    not_single_product: true,
    bundle_discount: 28.57142857142857, 
    bundle_components: [
      {id: 2433847951372, price:35.00} // FasciaYoga™ Ball
    ]
  },
  {
    bundle_name: 'My Body Hurts Kit',
    bundle_class: 'My_Body_Hurts_Kit',
    sold: false,
    bundle_discount: 31.12391930835735, 
    bundle_components: [
      {id: 39559479263328, price: 150.00}, // Blaster Base
      {id: 39559479459936, price: 89.00, qty: 2}, // Brush booster
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Blasting and Kryo Combo',
    bundle_class: 'Blasting_and_Kryo_Combo',
    sold: false,
    bundle_discount: 37.71428571428571, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32183262675040, price:57.00}, // Ashley Black's Kryomat™ Small
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Fire and Ice Kit',
    bundle_class: 'Fire_and_Ice_Kit',
    sold: false,
    bundle_discount: 44.19475655430712, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32669494214752, price:149.00}, // Ashley Black's Kryomat™ Medium 
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00}, // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: "The Easy Start Kit",
    bundle_class: 'The_Easy_Start_Kit',
    sold: false,
    bundle_discount: 50.1845018,
    not_single_product: true,
    bundle_components: [
      {id: 32588677152864, price:125.00}, // Mini PaddleBlaster ™
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
      {id: 32183156179040, price:22.00} // Wrap KryoPack
    ]
  },
  {
    bundle_name: 'Mini Paddle - Pre-Order',
    bundle_class: 'Mini_Paddle_Pre_Order',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 32588677152864, price:125.00} // Mini PaddleBlaster ™
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39559483818080, price:49.00}, // Mini Nugget Trigger Point with handle
        {id: 39559483949152, price:49.00}, // Lymphatic Gua Sha Flusher With handle
        {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
        {id: 39559492042848, price: 49.00}, // Fine Line Eraser With Handle
        {id: 39559432077408, price:15.00} // Satin cinch Bag
      ] 
    }
  },
  {
    bundle_name: 'Happy Feet, How Sweet',
    bundle_class: 'Happy_Feet_How_Sweet',
    sold: false,
    bundle_discount: 40.04796163069544, 
    bundle_components: [
      {id: 47113621132, price: 299.00}, // Ashley Black's™ Blaster Pod™ for Feet
      {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00} // FaceBlaster™
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
      {id: 39343279997024, price:64.00}, // Ashley Black’s Kryopack ™ Kryoboot
    ], 
  }},
    {
    bundle_name: 'ProBlaster',
    bundle_class: 'ProBlaster_Pre_Order',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39559483818080, price:49.00}, // Mini Nugget Trigger Point with handle
        {id: 39559483949152, price:49.00}, // Lymphatic Gua Sha Flusher With handle
        {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
        {id: 39559492042848, price: 49.00}, // Skin Invigorating Tool With Handle
        {id: 39559432077408, price:15.00} // Satin cinch Bag
      ] 
    }
  },
  {
    bundle_name: 'ProNugget',
    bundle_class: 'ProNugget_Pre_Order',
    sold: false,
    bundle_discount: 0, 
    bundle_components: [
      {id: 39747130654816, price: 125.00}, // ProNugget 
    ],
    free_components: {
      bundle_percentage: 100,
      free_bundle_componets: [
        {id: 39559483818080, price:49.00}, // Mini Nugget Trigger Point with handle
        {id: 39559483949152, price:49.00}, // Lymphatic Gua Sha Flusher With handle
        {id: 39559486308448, price: 49.00}, // Fine Line Eraser With Handle
        {id: 39559492042848, price: 49.00}, // Skin Invigorating Tool With Handle
        {id: 39559432077408, price:15.00} // Satin cinch Bag
      ] 
    }
  },
  {
    bundle_name: 'Layer by Layer Kit',
    bundle_class: 'Layer_by_Layer_Kit',
    sold: false,
    bundle_discount: 54.84848484848485, 
    bundle_components: [
      {id: 39559479459936, price: 89.00}, // Brush booster
      {id: 39510434545760, price: 125.00}, // ProBlaster™️️️️️️
      {id: 32917318565984, price:75.00, replace_variant:32917318598752, replace_price: 75.00}, // Mini 2™ 
      {id: 32183156179040, price:22.00}, // Ashley Black's Kryopack™ Wrap
      {id: 40134628999264, price:19.00, replace_variant: 40689249779808, replace_price:19.00} // NEW Blaster Oil
    ]
  },
  {
    bundle_name: 'Face Kit',
    bundle_class: 'Face_Kit',
    sold: false,
    bundle_discount: 66.5540541, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 39391782371424, price:149.00}, // OMGBlaster 
      {id: 32669495459936, price:59.00}, // Ashley Black's ™ Deluxe Serum 
      {id: 40689249779808, price:19.00, replace_variant: 40134628999264, replace_price:19.00} // Blaster Oil®️ Essentials
    ]
  },
  {
    bundle_name: 'Fasciablaster + Faceblaster',
    bundle_class: 'Fasciablaster_plus_Faceblaster',
    sold: false,
    bundle_discount: 20.23809523809524, 
    bundle_components: [
      {id: 32912436428896, price:99.00, replace_variant:32912436461664, replace_price: 99.00}, // FasciaBlaster®
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00} // FaceBlaster™
    ]
  },
  {
    bundle_name: 'Faceblaster Duo',
    bundle_class: 'Faceblaster_Duo',
    sold: false,
    bundle_discount: 41.40625, 
    bundle_components: [
      {id: 32917301756000, price:69.00, replace_variant:32917301788768, replace_price: 69.00}, // FaceBlaster™
      {id: 32669495459936, price: 59.00} // Ashley Black's ™ Deluxe Serum
    ]
  }
];

// if id null, select 3 display by most expensive
var bundles_per_handle = {
  //19824951165024: ['Celebrity_Kit', "Onyx_Initiator_Kit", "Platinum_Pack", "Budget_Box", 'Quick_Start_Kit', 'De-Stress_Pack', 'Celebrity_Kit']
};

var bundle_upsell = { /*Beginner_Kit: ["Platinum_Pack", "Back_Pack"]*/};

var subscribtion_products = [
  {variant_id: 32669495459936, name: 'Ashley Black\'s ™ Deluxe Serum', handle:'deluxe-serum', recharge_discount: 18, rc_price: '$48.38'},
  {variant_id: 19825070506080, name: '3.5 OZ AfterBlaster Cream™', handle: 'small-afterblaster-cream', recharge_discount: 7, rc_price: '$17.67'},
  //{variant_id: 19824951165024, name: '3.4 OZ Blaster Oil® Unscented', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 36058796684, name: 'FaceCare Essentials Kit', handle:'facekit-products', recharge_discount: 10, rc_price: '$31.50'},
  // {variant_id: 2474685038604, name: '12 OZ Blaster Oil®', handle:'12-oz-blaster-oil', recharge_discount: 10, rc_price: '$37.80'},
  {variant_id: 19824951165024, name: '3.4 OZ Blaster Oil®', handle:'small-oz-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 32669289447520, name: 'Roll On Blaster Oil', handle:'roll-on-blaster-oil', recharge_discount: 7, rc_price: '$17.67'},
  {variant_id: 39559478509664, name: 'Coffee scrub 8 oz', handle:'coffee-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'},
  {variant_id: 39559445905504, name: 'Lip scrub', handle:'lip-scrub', recharge_discount: 20, rc_price: '$17.60'},
  {variant_id: 39559433191520, name: "Ashley Black's Maximum Lip", handle:'lip-plump', recharge_discount: 20, rc_price: '$17.60'},
  {variant_id: 39559448756320, name: "LINEFIX", handle:'linefix', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559445119072, name: "Forehead Hydrogel (7 pack)", handle:'forehead-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559436730464, name: "Hydrogel Eye Patch (7 pack)", handle:'eye-patch-hydrogel-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559433781344, name: "Hydrogel Lip Patch (7 pack)", handle:'lip-patch-hydrogels-7-pack', recharge_discount: 20, rc_price: '$23.20'},
  {variant_id: 39559439941728, name: "Hydrogel Jawline Patch (7 pack)", handle:'lifting-patch-for-jaw-7-pack', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559441907808, name: "Hydrogel Décolleté Patch (7 pack)", handle:'decollete-neck-hydrogel-7-pack', recharge_discount: 20, rc_price: '$31.20'},
  {variant_id: 39559478739040, name: "Shea butter scrub 8 oz", handle:'shea-butter-scrub-8-oz', recharge_discount: 20, rc_price: '$28.00'}
];

var fake_product_name = {
  'pre-kit-platinum-pack': "FasciaBlaster Large Backpack, Extenders, FaceBlaster, FasciaBlaster, Blastersquad Headband, Ashley Black's Kryopack™ Face Wrap, Ashley Black's Kryomat™ Small, MasterBlaster, Mini 2, FasciaBlaster® Nugget"
}

var discount_products_base_on_qty = {};
var us_checkout_only = {'deluxe-serum': true}
var doubled_products = {
  "replacement-extender-rings": 1
}
var bf_2022_sale = {
  'gift-bag': [
    {id: 39642277150816, name: 'Tissue Paper', price: 0.01}
  ]
};


var bundle_description = {};
